import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class MultimediaService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createMultimedia(multimediaDevice): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(multimediaDevice);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/multimedia"}`;
    return this.http.post(url, data, { headers });
  }

  updateMultimedia(multimediaDevice): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(multimediaDevice);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/multimedia"}/${
      multimediaDevice?.code
    }`;
    return this.http.put(url, data, { headers });
  }
}
